// B2 fix (kimi re-gate review, 2026-10-31 — privacy on shared devices): the
// service-worker runtime cache persists user-scoped API snapshots under
// account-agnostic URLs (/api/me/permissions, /api/entitlements/me, per-condo
// permissions, /home/*?unitId=…). On logout and on every successful login the
// app asks the SW to sweep every /api/* entry from the runtime cache, so a
// different account signing in on the SAME browser profile (shared family
// tablet — a core Vecindus pattern) can never be served the previous account's
// cached permissions/entitlements/data offline. Fire-and-forget: no controller
// (first load) falls back to sw.ready; no SW at all is a no-op because no
// runtime cache was populated either. The SW side of the contract is the
// 'message' listener in public/sw.js.
const SW_AUTH_CACHE_SWEEP = { type: 'vecindus:auth-cache-sweep' } as const;

export function sweepServiceWorkerApiCache(): void {
  try {
    const sw = navigator.serviceWorker;
    if (!sw) return;
    if (sw.controller) { sw.controller.postMessage(SW_AUTH_CACHE_SWEEP); return; }
    void sw.ready
      .then((reg) => { reg.active?.postMessage(SW_AUTH_CACHE_SWEEP); })
      .catch(() => { /* SW never became ready: nothing was controlled */ });
  } catch { /* SW unsupported (tests / very old browsers) */ }
}
